import { AppState, RedirectLoginOptions, useAuth0 } from '@auth0/auth0-react'
import { Browser } from '@capacitor/browser'

import React, { ReactNode } from 'react'

import { AUTH0_LOGIN_SCOPE, isNativeApp, markSignupFlowPending } from '../config/auth0'
import { AuthStateContext } from '../providers/AuthStateContext'

interface RegisterButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  children?: ReactNode
}
export const RegisterButton = (props: RegisterButtonProps): JSX.Element => {
  const { children, onClick: onClickProp, ...rest } = props
  const isMobileDevice = isNativeApp()
  const { loginWithRedirect } = useAuth0()

  return (
    <button
      type="button"
      {...rest}
      onClick={(e) => {
        // separate redirectUrl like this since mobile devices don't get appState after redirect
        AuthStateContext.setRedirectUrl('/hospitals')

        let loginParams: RedirectLoginOptions<AppState> = {
          appState: { fromSignup: true, redirectUrl: '/hospitals' },
          authorizationParams: { scope: AUTH0_LOGIN_SCOPE, screen_hint: 'signup' },
        }
        if (isMobileDevice) {
          loginParams = {
            ...loginParams,
            async openUrl(url) {
              // Redirect using Capacitor's Browser plugin
              await Browser.open({
                url,
                windowName: '_self',
              })
            },
          }
        }
        // Set signup flow flag so OnboardingModal shows after registration.
        // localStorage persists through Auth0's full-page redirect.
        markSignupFlowPending()
        loginWithRedirect(loginParams)
        onClickProp?.(e)
      }}
    >
      {children || 'Register'}
    </button>
  )
}
